<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 3.9rem">
      <el-row type="flex" justify="space-between" class="sub-title">
        <div>
          门诊分诊：
          <el-button
            type="primary"
            size="large"
            icon="el-icon-document-add"
            @click="meta.showSetting = true"
            v-if="permission.registration_triage_config"
            >分诊配置</el-button
          >
          <el-button
            type="warning"
            size="large"
            icon="el-icon-s-tools"
            @click="meta.showAdjust = true"
            v-if="permission.registration_triage_adjust"
            >队列调整</el-button
          >
          <el-button type="primary" size="large" @click="meta.showCallScreen = true">叫号屏</el-button>
        </div>
      </el-row>
    </el-header>
    <el-main class="center" style="padding: 0px">
      <el-row style="width: 35rem" class="main-table">
        <el-row v-if="!hasDept">
          <strong style="font-size: 2rem"> 当前客户端未绑定门诊科室！ </strong>
        </el-row>
        <el-row v-else-if="!hasSetting">
          <h1 style="font-size: 1.5rem">{{ triageDept | dictText("Dept") }}</h1>
          <strong style="font-size: 2rem"> 当前科室缺少分诊配置！ </strong>
        </el-row>
        <el-row v-else>
          <h1 style="font-size: 1.5rem">{{ triageDept | dictText("Dept") }}</h1>
          <el-form ref="form" :model="meta.form" @submit.native.prevent>
            <el-form-item label=" " prop="idNo">
              <el-input
                size="small"
                v-model="meta.form.opNo"
                placeholder="请输入"
                @keyup.enter.native="searchOpNo"
                clearable
              >
                <el-button
                  slot="append"
                  :loading="meta.searching"
                  @click="searchOpNo"
                  icon="el-icon-search"
                  v-if="permission.registration_triage_lineup"
                  >查询</el-button
                >
              </el-input>
            </el-form-item>
          </el-form>
          <el-row v-if="reg">
            <el-row
              v-if="reg.id"
              type="flex"
              justify="start"
              align="middle"
              style="line-height: 3rem; text-align: left"
            >
              <el-avatar shape="square" :size="50">
                <i class="el-icon-user-solid" style="font-size: 3rem" />
              </el-avatar>
              <span style="font-size: 1rem" class="left-pad">
                <span class="left-pad">
                  <span style="color: #aaa">患者姓名：</span
                  >{{ reg.patientName }}</span
                >
                <span class="left-pad">
                  <span style="color: #aaa">就诊科室：</span
                  >{{ reg.deptName }}</span
                ><br />
                <span class="left-pad">
                  <span style="color: #aaa">号别：</span
                  >{{ reg.regType | dictText("RegType") }}</span
                >
                <span v-if="reg.doctorName" class="left-pad">
                  <span style="color: #aaa">医师：</span
                  >{{ reg.doctorName }}</span
                >
                <span class="left-pad">
                  <span style="color: #aaa">午别：</span
                  >{{ reg.periodType }}</span
                >
                <span class="left-pad">
                  <span style="color: #aaa">序号：</span>{{ reg.seqNo }}</span
                > </span
              ><br />
            </el-row>
            <el-alert v-if="!errMsg" type="warning" center :closable="false">
              <strong style="font-size: 1.5rem; line-height: 3rem"
                >您已在候诊队列中<br />
                <table style="border: none">
                  <tr>
                    <td>医师：</td>
                    <td>{{ patient.doctorName }}</td>
                  </tr>
                  <tr>
                    <td>诊室：</td>
                    <td>{{ patient.roomName }}</td>
                  </tr>
                </table>
                <span v-if="patient.before == 0"
                  >马上就要到您就诊，请您做好准备！</span
                >
                <span v-else
                  >您前面还有{{ patient.before }}位患者，请您耐心等候！</span
                >
              </strong>
            </el-alert>
            <el-alert v-else type="warning" center :closable="false">
              <strong style="font-size: 1.5rem; line-height: 3rem">{{
                errMsg
              }}</strong>
            </el-alert>
          </el-row>
          <el-row v-if="!reg">
            <strong style="font-size: 2rem">
              请扫描挂号凭证上的就诊号条形码<br />
              或者<br />
              输入就诊号并点击查询
            </strong>
          </el-row>
        </el-row>
      </el-row>
    </el-main>
    <el-dialog
      title="叫号屏"
      :visible.sync="meta.showCallScreen"
      width="32rem"
      :close-on-click-modal="false"
      @open="openCallScreen"
    >
      <el-form label-width="5rem" @submit.native.prevent>
        <el-form-item label="医生">
          <el-select
            v-model="callScreen.doctor"
            placeholder="请选择医生"
            filterable
            clearable
            value-key="id"
            style="width: 100%"
            :loading="callScreen.loadingDoctors"
            @change="changeCallScreenDoctor"
            @clear="clearCallScreenDoctor"
          >
            <el-option
              v-for="item in validCallScreenDoctors"
              :key="item.id"
              :value="item"
              :label="item.targetType == '科室' ? item.deptName : item.doctorName"
            >
              <span v-if="item.targetType == '科室'">{{ item.deptName }}</span>
              <span v-if="item.targetType == '专家'">
                <small style="color:#BBB">{{ item.deptName }}：</small>{{ item.doctorName }}
              </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="诊室">
          <el-select
            v-model="callScreen.room"
            placeholder="请选择诊室"
            filterable
            clearable
            value-key="no"
            style="width: 100%"
            :disabled="!callScreen.doctor"
            :loading="callScreen.loadingRooms"
          >
            <el-option
              v-for="room in callScreen.rooms"
              :key="room.no"
              :value="room"
              :label="room.name"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" :loading="callScreen.loggingIn" @click="callScreenLogin">登录</el-button>
        <el-button :loading="callScreen.loggingOut" @click="callScreenLogout">登出</el-button>
      </span>
    </el-dialog>
    <setting :visible.sync="meta.showSetting" @close="refresh"></setting>
    <adjust :visible.sync="meta.showAdjust"> </adjust>
  </el-container>
</template>

<script>
import api from "./api";
import commonApi from "@/common/api";
import { mapGetters } from "vuex";
export default {
  components: {
    setting: () => import("./setting"),
    adjust: () => import("./adjust"),
  },
  data() {
    return {
      loading: false,
      reg: null,
      patient: {},
      setting: null,
      meta: {
        showSetting: false,
        showClinic: false,
        showCallScreen: false,
        searching: false,
        showAdjust: false,
        form: {
          opNo: "",
        },
      },
      callScreen: {
        doctor: null,
        room: null,
        rooms: [],
        doctorStaffs: [],
        loadingDoctors: false,
        loadingRooms: false,
        loggingIn: false,
        loggingOut: false,
      },
      errMsg: null,
    };
  },
  computed: {
    ...mapGetters(["user", "dict", "triageDept", "permission"]),
    hasDept() {
      return !!this.triageDept;
    },
    hasSetting() {
      return this.setting && this.setting.id;
    },
    validCallScreenDoctors() {
      if (!this.dict.OpTarget) {
        return [];
      }
      return this.dict.OpTarget.filter((item) => {
        return item && item.targetType == "专家";
      }).sort((a, b) => {
        return a.deptCode != b.deptCode
          ? a.deptCode.localeCompare(b.deptCode)
          : (a.doctorId || 0) - (b.doctorId || 0);
      });
    },
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    openCallScreen() {
      this.queryCallScreenDoctors();
      if (this.callScreen.doctor) {
        this.queryCallScreenRooms();
      }
    },
    clearCallScreenDoctor() {
      this.callScreen.doctor = null;
      this.callScreen.room = null;
      this.callScreen.rooms = [];
    },
    async changeCallScreenDoctor() {
      this.callScreen.room = null;
      await this.queryCallScreenRooms();
    },
    async queryCallScreenRooms() {
      if (!this.callScreen.doctor) {
        this.callScreen.rooms = [];
        return;
      }
      this.callScreen.loadingRooms = true;
      try {
        if (!this.callScreen.doctor.deptCode) {
          this.$message.warning("当前医生缺少科室编码");
          this.callScreen.rooms = [];
          return;
        }
        let res = await api.getTriageSetting(this.callScreen.doctor.deptCode);
        this.callScreen.rooms = (res && res.rooms) || [];
      } catch (err) {
        this.callScreen.rooms = [];
        this.$message.error(err.message || err);
      } finally {
        this.callScreen.loadingRooms = false;
      }
    },
    async queryCallScreenDoctors() {
      if (this.callScreen.doctorStaffs.length) {
        return;
      }
      this.callScreen.loadingDoctors = true;
      try {
        let res = await commonApi.queryStaff({
          ifOp: true,
          pageIndexOnView: 1,
          pageSize: 9999,
          pageIndex: 0,
        });
        this.callScreen.doctorStaffs = Array.isArray(res.items) ? res.items : [];
      } catch (err) {
        this.callScreen.doctorStaffs = [];
        this.$message.error(err.message || err);
      } finally {
        this.callScreen.loadingDoctors = false;
      }
    },
    getCallScreenDoctorAccount(doctorId) {
      let doctor = this.callScreen.doctorStaffs.find((item) => item.id == doctorId);
      return doctor && doctor.account;
    },
    async getCallScreenParams() {
      if (!this.callScreen.doctor) {
        this.$message.warning("请选择医生");
        return null;
      }
      if (!this.callScreen.room) {
        this.$message.warning("请选择诊室");
        return null;
      }
      if (!this.callScreen.doctor.deptCode) {
        this.$message.warning("当前医生缺少科室编码");
        return null;
      }
      let doctorId = this.callScreen.doctor.doctorId || this.callScreen.doctor.id;
      if (!doctorId) {
        this.$message.warning("当前医生缺少医生ID");
        return null;
      }
      let account = this.getCallScreenDoctorAccount(doctorId);
      if (!account) {
        await this.queryCallScreenDoctors();
        account = this.getCallScreenDoctorAccount(doctorId);
      }
      if (!account) {
        this.$message.warning("当前医生缺少账号");
        return null;
      }
      let roomId = this.callScreen.room.id || this.callScreen.room.no;
      if (roomId === null || roomId === undefined || roomId === "") {
        this.$message.warning("当前诊室缺少诊室ID");
        return null;
      }
      return {
        departmentId: this.callScreen.doctor.deptCode,
        account,
        doctorId,
        roomId,
      };
    },
    async callScreenLogin() {
      let para = await this.getCallScreenParams();
      if (!para) {
        return;
      }
      this.callScreen.loggingIn = true;
      try {
        await api.callLogin(para);
        this.$message.success("叫号屏登录成功");
      } catch (err) {
        this.$message.error(err.message || err);
      } finally {
        this.callScreen.loggingIn = false;
      }
    },
    async callScreenLogout() {
      let para = await this.getCallScreenParams();
      if (!para) {
        return;
      }
      this.callScreen.loggingOut = true;
      try {
        await api.callLogout(para);
        this.$message.success("叫号屏登出成功");
      } catch (err) {
        this.$message.error(err.message || err);
      } finally {
        this.callScreen.loggingOut = false;
      }
    },
    async refresh() {
      try {
        if (this.hasDept) {
          let res = await api.getTriageSetting(this.triageDept); //查看是否存在科室配置信息
          this.setting = res;
        } else {
          this.setting = null;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async searchOpNo() {
      if (!this.meta.form.opNo || !this.meta.form.opNo.trim()) {
        return;
      }
      this.meta.searching = true;
      try {
        let res = await api.queryReg(this.meta.form);
        // console.log('res', res)
        let reg = res.items[0];
        if (!res.items.length) {
          throw new Error("抱歉，未找到此就诊号，请确认就诊号是否正确!");
        }
        if (reg.deptCode != this.triageDept) {
          throw new Error(
            "您扫描的就诊号不属于当前科室，请您确认是否走错了位置。"
          );
        }
        let lineInfo = await api.patientJoinQueue(reg.opNo);
        if (!lineInfo) {
          throw new Error(`当前科室未配置就诊医生【${reg.doctorName}】。`);
        }
        let roomNo = lineInfo.roomNo;
        let room = this.setting.rooms.find((r) => r.no == roomNo);
        lineInfo.roomName = room ? room.name : "";
        this.patient = lineInfo;
        this.reg = reg; // 最后赋值给就诊号，是为了避免提前在画面显示了不该显示的信息
      } catch (err) {
        this.reg = {}; // 为了显示异常信息，需要赋个空对象
        this.errMsg = err.message || err;
      } finally {
        this.meta.searching = false;
        this.meta.form.opNo = null;
        setTimeout(() => {
          this.errMsg = null;
          this.reg = null;
          this.patient = {};
        }, 10 * 1000);
      }
    },
  },
};
</script>
